'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _lodash = _interopRequireDefault(require("lodash.assign"));

var _translate = _interopRequireDefault(require("./../translate"));

var _conf = _interopRequireDefault(require("../../conf"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var urlService = require('../../../server/services/url-encoder');

var SearchResults = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchResults, _React$Component);

  function SearchResults(props) {
    var _this;

    _classCallCheck(this, SearchResults);

    _this = _possibleConstructorReturn(this, (SearchResults.__proto__ || Object.getPrototypeOf(SearchResults)).call(this, props));
    _this.getAddress = _this.getAddress.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SearchResults, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          i18n = _this$props.i18n,
          t = _this$props.t,
          theme = _this$props.theme; // priority of projects used for detail view url

      var priorities = _conf.default.priorities;
      setTimeout(function () {
        window.addEventListener('scroll', _this2.checkViewportOffsetVisible);
      }, 500);
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, !isNaN(this.props.numberOfResults) && this.props.numberOfResults > 0 && /*#__PURE__*/_react.default.createElement("div", {
        className: "search-results-title"
      }, this.props.t('search-result', {
        count: parseInt(this.props.numberOfResults)
      })), this.props.numberOfResults === 0 && /*#__PURE__*/_react.default.createElement("div", {
        className: "search-results-title"
      }), this.props.showBrunchSoldout && /*#__PURE__*/_react.default.createElement("div", {
        className: "filter-soldout"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "checkbox",
        className: "filter-soldout-check",
        id: 'filter-soldout-check',
        onClick: function onClick() {
          return _this2.props.setBrunchSoldout();
        },
        defaultChecked: false
      }), /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: 'filter-soldout-check'
      }, t('show-soldout'))), /*#__PURE__*/_react.default.createElement("div", {
        className: "card-wrapper"
      }, this.props.farms.map(function (farm) {
        var urlEncoded = urlService(farm.farmname);

        var soldout = false,
            address = _this2.getAddress(farm),
            displayOutletsInfo = false;

        if (farm.brunch) {
          soldout = farm.brunch.soldout;
        }

        if (theme === 'vomhof' && farm.vomhof && farm.vomhof.outlets && farm.vomhof.outlets.length) {
          displayOutletsInfo = true;
        }

        var imageStyle = {};

        if (farm.mainImage && farm.mainImage.id) {
          imageStyle.backgroundImage = "url('/api/files/".concat(farm.mainImage.id, "/large')");
        } else {
          imageStyle.backgroundImage = 'url(\'/static/assets/images/placeholder.png\')';
        }

        var projectToSetinURL = '',
            hasProjectFilters = false,
            prioritizedProjects = []; // check if any project filters are set

        if (_this2.props.filters.project) {
          hasProjectFilters = _this2.props.filters.project.filter(function (obj) {
            return Object.keys(obj).length > 0;
          }).length > 0; // sort active filters by priority if no filters are set

          if (!hasProjectFilters) {
            _this2.props.filters.project.sort(function (a, b) {
              var aPriority = priorities.find(function (priority) {
                return priority.name === a.filterKey;
              }).priority;
              var bPriority = priorities.find(function (priority) {
                return priority.name === b.filterKey;
              }).priority;
              return aPriority - bPriority;
            });
          }
        } // Use the first index of the filtered projects in the URL if filters are active,
        // otherwise use first index in priority list


        if (hasProjectFilters && _this2.props.filters.project[0].filterKey in farm) {
          var urlKey; // check if project exists in farm

          for (var i = 0; i < _this2.props.filters.project.length; i++) {
            var project = _this2.props.filters.project[i].filterKey;

            if (farm[project]) {
              urlKey = _this2.props.filters.project[i].filterKey;
              break;
            }
          }

          projectToSetinURL = '/' + t("".concat(urlKey, "-filter"));
        } else {
          priorities.forEach(function (priority) {
            if (farm[priority.name] !== null) {
              prioritizedProjects.push(priority.name);
            }
          });
          projectToSetinURL = '/' + t("".concat(prioritizedProjects[0], "-filter"));
        }

        if (theme === 'schub') {
          projectToSetinURL = '/' + t('schub-filter');
        }

        return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
          to: "/".concat(i18n.language, "/farm/").concat(urlEncoded, "-").concat(farm.id).concat(projectToSetinURL),
          key: farm.id
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "card ".concat(i18n.language).concat(soldout ? ' soldout' : ''),
          id: "".concat(farm.id),
          title: "".concat(address.farmname, ", ").concat(address.zip, " ").concat(address.city)
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: 'card-image-wrapper'
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "card-image",
          style: imageStyle
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "card-section"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: 'content'
        }, address.farmname && address.farmname.length > 0 && /*#__PURE__*/_react.default.createElement("b", null, address.farmname), /*#__PURE__*/_react.default.createElement("p", null, address.zip, " ", address.city)), displayOutletsInfo && /*#__PURE__*/_react.default.createElement("p", {
          className: 'footer'
        }, t('Weitere Verkaufsstellen')))));
      })));
    }
  }, {
    key: "getAddress",
    value: function getAddress(farm) {
      var _this$props2 = this.props,
          theme = _this$props2.theme,
          filters = _this$props2.filters;
      var projectsWithCities = _conf.default.projectKeysWithCities;
      var farmProjectCities = [];
      var result = {
        farmname: farm.farmname,
        zip: farm.zip,
        city: farm.city
      }; // push available projects with cities to separate array

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = filters.project[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _filter = _step.value;

          if (projectsWithCities.includes(_filter.filterKey)) {
            farmProjectCities.push(_filter.filterKey);
          }
        } // only override city if the project filter contains a single project

      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (farmProjectCities.length === 1) {
        var key = farmProjectCities[0];

        if (farm[key] && farm[key].city) {
          result.city = farm[key].city;
        }
      }

      if (theme && farm[theme]) {
        result.zip = farm[theme].zip || farm.zip;
        result.city = farm[theme].city || farm.city;
        result.farmname = farm[theme].eventlocation || farm.farmname;

        if (theme === 'brunch') {
          result.farmname = farm[theme].brunchlocation || farm.farmname;
        }
      }

      return result;
    }
  }]);

  return SearchResults;
}(_react.default.Component);

SearchResults.propTypes = {
  farms: _propTypes.default.array,
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string
  }),
  filters: _propTypes.default.shape({
    project: _propTypes.default.array
  }),
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired,
    location: _propTypes.default.shape({
      pathname: _propTypes.default.string,
      hash: _propTypes.default.string,
      search: _propTypes.default.string
    }),
    listen: _propTypes.default.func
  }),
  theme: _propTypes.default.string,
  numberOfResults: _propTypes.default.number,
  detailViewSearch: _propTypes.default.string,
  detailViewPath: _propTypes.default.string,
  setBrunchSoldout: _propTypes.default.func,
  t: _propTypes.default.func,
  showBrunchSoldout: _propTypes.default.bool
};

var mapStateToProps = function mapStateToProps(state) {
  return (0, _lodash.default)({}, state.farm);
};

var _default = (0, _reactRedux.connect)(mapStateToProps)((0, _translate.default)(SearchResults));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/search-results/index.js
// module id = 881
// module chunks = 0